import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface IHttpErrorModalParameters {
  error: HttpErrorResponse;
}
@Component({
  selector: 'app-http-error-modal',
  templateUrl: './http-error-modal.component.html',
})
export class HttpErrorModalComponent {
  public Error: IHttpErrorModalParameters;

  constructor(private _activeModal: NgbActiveModal) {
    // @ts-expect-error - default parameters
    this.Error = { error: null };
  }

  public get error(): Error {
    return this.Error.error;
  }
  public dismiss(): void {
    this._activeModal.dismiss();
  }
}
